<template>
    <v-dialog
            v-model="modelValue"
            :width="1000"
            persistent
    >
        <v-card>
            <div class="">
                <div class="d-flex align-center primary pl-3 pr-2">
                    <div class="flex-grow-1 sub--text">
                        Batch Disable
                    </div>
                    <div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="modelValue = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="" style="overflow-x: hidden; overflow-y: hidden">
                    <v-tabs v-model="page">
                        <v-tab>
                            Data
                        </v-tab>
                        <v-tab :disabled="!importDataRaw || !importFarm">
                            Review
                        </v-tab>
                        <v-tab :disabled="!importDataRaw || !importFarm || !importData || !importData.length">
                            Process
                        </v-tab>
<!--Data-->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="py-0">
                                    <v-textarea
                                            class="pt-3"
                                            label="Please Paste Data From Excel Here, Clock Numbers only"
                                            hide-details
                                            color="primary"
                                            v-model="importDataRaw"
                                            rows="5"
                                    />
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            :disabled="!importDataRaw "
                                            small
                                            color="primary"
                                            @click="page = ++page"
                                    >Next</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>

<!--Review-->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="pa-0" style="overflow-x: auto">
                                    <v-data-table
                                            :headers="importHeaders"
                                            :items="importData"
                                            :items-per-page="5"
                                            class="elevation-1"
                                            style="min-width: 1000px"
                                    ></v-data-table>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            :disabled="!importData || !importData.length"
                                            small
                                            color="primary"
                                            @click="page = ++page"
                                    >Next</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="py-0">
                                    <div class="d-flex font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Processed:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.processed}}</div>
                                    </div>
                                    <div class="d-flex green--text font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Updated:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.updated}}</div>
                                    </div>
                                    <div class="d-flex red--text font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Errors:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.errors}}</div>
                                    </div>
                                    <v-progress-linear class="my-2" color="secondary" :value="importResult.progress"/>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            v-if="!importResult.ran"
                                            small
                                            color="primary"
                                            @click="startRun()"
                                    >Start Batch Disable</v-btn>
                                    <v-btn
                                            v-else
                                            :disabled="importing"
                                            :loading="importing"
                                            small
                                            color="primary"
                                            @click="modelValue = false"
                                    >Done</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </div>
<!--                <div class="text-right pr-2 pt-2 pb-2">-->
<!--                    <v-btn-->
<!--                            @click="validateSave()"-->
<!--                            fab-->
<!--                            small-->
<!--                            color="secondary"-->
<!--                            :loading="loading"-->
<!--                            :disabled="!changesMade || loading"-->
<!--                    >-->
<!--                        <v-icon v-if="!loading">mdi-content-save</v-icon>-->
<!--                    </v-btn>-->
<!--                </div>-->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import emp from "@/components/Setup/Emp/Emp";

function download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

import {mapGetters} from "vuex";
import {waitForEvent} from "@/core/socket";

export default {
    components: {},
    props: {
        value: Boolean,
    },
    data() {
        return {
            page: 0,
            importFarm: null,
            importDataRaw: null,
            importHeaders: [
                {value: 'fullName', text: 'Full Name', sortable: true},
                {value: 'idNo', text: 'ID No', sortable: true},
                {value: 'empCode', text: 'Emp Code', sortable: true},
                {value: 'fkFarm', text: 'Import Farm', sortable: true},
                {value: 'team', text: 'Team', sortable: true},
                {value: 'jobDesc', text: 'Job Description', sortable: true},
            ],
            importResult: {
                ran: false,
                index: 0,
                progress: 0,
                processed: 0,
                errors: 0,
                updated: 0,
                inserted: 0
            },
            importing: false
        }
    },
    watch: {
        page: {
            immediate:true,
            handler(val) {

                if (val === 2)
                    this.importResult = {
                        ran: false,
                        index: 0,
                        progress: 0,
                        processed: `0 of ${this.importData.length}`,
                        errors: 0,
                        updated: 0,
                        inserted: 0
                    }
            }
        }
    },
    methods: {

        async disableEmp(emp) {
            const eventID = await this.$newReq('POST', `setup/emp`, {...emp, disabled: 1})
            const addedEmpID = (await waitForEvent(eventID)).emp.pop().id
            return addedEmpID
        },

        async startRun() {

            this.importResult.ran = true

            const vm = this
            const errors = [];
            const disableEmployee = (item) => {
                return new Promise( (resolve) => {
                    this.disableEmp(item)
                            .then(() => {
                                vm.importResult.updated = ++vm.importResult.updated
                            })
                            .catch(e => {
                                if (e.response.status === 406) {
                                    errors.push(item)
                                }
                                vm.importResult.errors = ++vm.importResult.errors
                            })
                            .finally(() => {
                                vm.importResult.index = ++vm.importResult.index
                                vm.importResult.progress = Math.floor(((vm.importResult.index + 1) / vm.importData.length) * 100)
                                vm.importResult.processed = `${vm.importResult.index} of ${vm.importData.length}`
                                resolve(true)
                            })
                })
            }
            this.importing = true;

            for (const row of this.importData) {
                await disableEmployee(row)
            }

            console.log(errors)

            if (errors.length) {

                const xls = require('json-as-xlsx');
                let data = [{
                    sheet: "Disable Errors",
                    columns: [
                        {value: 'fullName', label: 'Full Name'},
                        {value: 'idNo', label: 'ID No'},
                        {value: 'empCode', label: 'Emp Code'},
                        {value: 'fkFarm', label: 'Import Farm'},
                        {value: 'team', label: 'Team'},
                        {value: 'jobDesc', label: 'Job Description'},
                    ],
                    content: errors.map((errLine) => {
                        return {...errLine, reason: this.farmsRef[errLine.actualFarm].description}
                    })
                }]
                let settings = {
                    fileName: "Disable Errors.xlsx",
                }

                xls(data, settings)
            }

            this.importing = false;
        }
    },
    computed: {
        ...mapGetters(['farms', 'farmsRef', 'emp']),

        importData() {
            try {
                let rows = this.importDataRaw
                        .split(/\n/g)
                        .filter(code => !!code)
                        .map(code => +code)
                const disableEmployees = this.emp.filter(employee => rows.includes(+employee.empCode))
                return disableEmployees
            } catch (e) {
                return 'null'
            }
        },


        modelValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>

<style scoped>

</style>